import { cn } from '@/utils'

export function CenteredContent({ children, className = 'max-w-[400px]' }: { children: React.ReactNode; className?: string }) {
    return <div className={cn('mx-auto mt-16 flex w-full flex-col gap-5 transition-all duration-300 ease-in-out', className)}>{children}</div>
}
